import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';
import AboutSection from '../About/About';
import CompanyScroller from '../CompanyScroller/CompanyScroller';
import Contact from '../Contact/Contact';
import CustomCarousel from '../CustomCarousel/CustomCarousel';
import LetsDiscussSection from '../LetsDiscussSection/LetsDiscussSection';
import Services from '../Service/Service';
import ImageSlider from '../Slider/ImageSlider';

/* Scroll-triggered reveal — replaces the old on-load animation
   so sections animate as the user reaches them, not all at once. */
const Reveal = ({ children, direction = 'up', delay = 0 }) => {
  const offsets = {
    up: { x: 0, y: 40 },
    left: { x: -60, y: 0 },
    right: { x: 60, y: 0 },
  };
  const from = offsets[direction] || offsets.up;
  return (
    <motion.div
      initial={{ opacity: 0, ...from }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

/* Subtle section wrapper — gives each block consistent vertical rhythm
   and an optional tinted background, without touching the inner component. */
const Section = ({ tint, divider, children, sx }) => (
  <Box
    sx={{
      position: 'relative',
      py: { xs: 4, md: 6 },
      background:
        tint === 'soft'
          ? 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
          : tint === 'cool'
          ? 'linear-gradient(135deg, #f0f4f8 0%, #e0e7ee 100%)'
          : tint === 'warm'
          ? 'linear-gradient(180deg, #fff8f3 0%, #ffffff 100%)'
          : 'transparent',
      borderTop: divider ? '1px solid rgba(11,36,71,0.06)' : 'none',
      ...sx,
    }}
  >
    {children}
  </Box>
);

function Home() {
  return (
    <Box sx={{ overflowX: 'hidden' }}>
      {/* Carousel — kept as your hero, with a clean entrance */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <CustomCarousel />
      </motion.div>

      {/* Small breathing room so CompanyScroller reads as a separate section */}
      <Box sx={{ height: { xs: 16, md: 24 }, background: '#fff' }} />

      <Reveal direction="right">
        <CompanyScroller />
      </Reveal>

      <Section tint="warm" divider>
        <Reveal direction="left">
          <Contact />
        </Reveal>
      </Section>

      <Section tint="soft" divider>
        <Reveal direction="right">
          <AboutSection />
        </Reveal>
      </Section>

      <Section divider>
        <Reveal direction="left">
          <Services />
        </Reveal>
      </Section>

      <Section tint="warm" divider>
        <Reveal direction="right">
          <LetsDiscussSection />
        </Reveal>
      </Section>

      <Section tint="cool" divider>
        <Reveal direction="left">
          <ImageSlider />
        </Reveal>
      </Section>
    </Box>
  );
}

export default Home;
